import * as TickersConstants from '../constants/tickers-constants';
import API from '../api/tickers-api';

//Actions for put Ticker
export const putTicker = (data) => dispatch => {
    dispatch(putTickerRequest(data));
    API.putTicker(data)
      .then(response => {
        dispatch(putTickerSuccess(response));
      })
      .catch(error => {
        dispatch(putTickerFailure(error))
      })
  }
  
  const putTickerRequest = (data) => {
    return {
      type: TickersConstants.CREATE_TICKER_BEGIN,
      data
    }
  }
  
  const putTickerSuccess = (data) => {
    return {
      type: TickersConstants.CREATE_TICKER_SUCCESS,
      data
    }
  }
  
  const putTickerFailure = (e) => {
    return {
      type: TickersConstants.CREATE_TICKER_FAILURE,
      error: e
    }
  }
  
  //Actions for get Tickers
  export const getTickers = (data) => dispatch => {
    dispatch(getTickersRequest(data));
    API.getTickers(data)
      .then(response => {
        dispatch(getTickersSuccess(response));
      })
      .catch(error => {
        dispatch(getTickersFailure(error))
      })
  }
  
  const getTickersRequest = (data) => {
    return {
      type: TickersConstants.GET_TICKER_BEGIN,
      data
    }
  }
  
  const getTickersSuccess = (data) => {
    return {
      type: TickersConstants.GET_TICKER_SUCCESS,
      data
    }
  }
  
  const getTickersFailure = (e) => {
    return {
      type: TickersConstants.GET_TICKER_FAILURE,
      error: e
    }
  }